import React from "react";
import { Stack } from "@mui/material";
import Icon from "src/components/icon";
import githubIcon from "src/assets/icons/github-int";
import gitlabIcon from "src/assets/icons/gitlab-int";
import googleWorkspaceIcon from "src/assets/icons/google-workspace-int";
import slackIcon from "src/assets/icons/slack-int";
import jiraIcon from "src/assets/icons/jira-int";
import notionIcon from "src/assets/icons/notion-int";
import styled from "styled-components";

const InfoText = styled.p`
    margin: 0;
    font-size: 12px;
    font-weight: 200;
`;

const calculateIntegrationDependencies = (dependencies) => {
    if (!dependencies) return null;
    const capitalizeFirstLetter = (string) => {
        if (!string) return "";
        return string.charAt(0).toUpperCase() + string.slice(1);
    };
    return dependencies.map((dependency) => {
        if (dependency.name === "git") {
            return (
                <Stack direction="row" spacing={1} key={dependency.name} m={0.5}>
                    <Icon svg={githubIcon} fill="palette.primary.main" />
                    <Icon svg={gitlabIcon} fill="palette.primary.main" />
                    <InfoText>{capitalizeFirstLetter(dependency.name)}</InfoText>
                </Stack>
            );
        }
        if (dependency.name === "calendar" || dependency.name === "calendar-centrally-managed") {
            return (
                <Stack direction="row" spacing={1} key={dependency.name} m={0.5}>
                    <Icon svg={googleWorkspaceIcon} fill="palette.primary.main" />
                    <InfoText>{capitalizeFirstLetter(dependency.name)}</InfoText>
                </Stack>
            );
        }
        if (dependency.name === "slack") {
            return (
                <Stack direction="row" spacing={1} key={dependency.name} m={0.5}>
                    <Icon svg={slackIcon} fill="palette.primary.main" />
                    <InfoText>{capitalizeFirstLetter(dependency.name)}</InfoText>
                </Stack>
            );
        }
        if (dependency.name === "pm") {
            return (
                <Stack direction="row" spacing={1} key={dependency.name} m={0.5}>
                    <Icon svg={jiraIcon} fill="palette.primary.main" />
                    <Icon svg={notionIcon} fill="palette.primary.main" />
                    <InfoText>{capitalizeFirstLetter(dependency.name)}</InfoText>
                </Stack>
            );
        }
        return null;
    });
};

export default calculateIntegrationDependencies;
